import {
  ResolvedGalleryItemHtmlInfoCUEElement,
  ResolvedGalleryItemImageCUEElement,
} from "@app/layouts/Article/elements";
import styles from "@app/layouts/Article/Storyline.module.css";
import { Typography } from "@sphtech/dmg-design-system";
import { getGeniusLink } from "@src/app/utils/trackers/skimlinks";

type GalleryItemTitleProps = {
  info:
    | ResolvedGalleryItemImageCUEElement
    | ResolvedGalleryItemHtmlInfoCUEElement
    | undefined;
};

const GalleryItemTitle = ({ info }: GalleryItemTitleProps) => {
  const text = info?.additionalFields.title?.value;
  if (!text) {
    return null;
  }
  return (
    <Typography.Heading.SubHeading>
      {info.additionalFields.targetUrl?.value ? (
        <a
          href={getGeniusLink(info.additionalFields.targetUrl.value)}
          className={styles.externalLinks}
          rel="noopener nofollow noreferrer"
          target="_blank"
        >
          {text}
        </a>
      ) : (
        text
      )}
    </Typography.Heading.SubHeading>
  );
};

export default GalleryItemTitle;
